import { render } from "./SecondOpinionRequestEdit.vue?vue&type=template&id=d273171e&scoped=true&ts=true"
import script from "./SecondOpinionRequestEdit.vue?vue&type=script&lang=ts"
export * from "./SecondOpinionRequestEdit.vue?vue&type=script&lang=ts"

import "./SecondOpinionRequestEdit.vue?vue&type=style&index=0&id=d273171e&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d273171e"]])

export default __exports__